import { Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DESKTOP_MIN_WIDTH } from '../../basics/cconstants/bosch-ui-desktop-width.constant';

@Directive({
  selector: '[showOnScreen]',
  standalone: true,
})
export class BoschUiShowOnScreenDirective {
  @Input()
  set showOnScreen(type: 'desktop' | 'mobile') {
    if (!this.hasView) {
      const SCREEN_WIDTH = (this.document.defaultView && this.document.defaultView.innerWidth) || 0;
      if (SCREEN_WIDTH < DESKTOP_MIN_WIDTH && type === 'mobile') {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }

      if (SCREEN_WIDTH >= DESKTOP_MIN_WIDTH && type === 'desktop') {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
      this.hasView = true;
    }
  }

  private hasView = false;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainerRef: ViewContainerRef,
    @Inject(DOCUMENT) private document: Document,
  ) {}
}
